<div class="page">
    <div class="container-fluid">
        <div class="row page-header">
            <div class="col-md-6">
                <h3>Internal Assessments <br>
                    <small>{{batch.course.name}} - Batch {{batch.start_year}}</small>
                </h3>
            </div>

            <div class="col-md-6 text-right">
                
            </div>
        </div>

        <div class="page-body">
            
            <ng-container *ngFor="let year of data">
                <h5 class="mb-4">Year: {{year.name}}</h5>

                <div class="row">
                    <div class="col-4 mb-4" *ngFor="let subject of year.syllabus">
                        <div class="btn-timetable" routerLink="/dashboard/internal-assessment/{{batchId}}/{{subject.id}}">
                            <h5>{{subject.topic}}</h5>
                        </div>
                    </div>
                </div>

            </ng-container>
            
        </div>
    </div>
</div>
